module.exports = __webpack_public_path__ + "assets/img/logo-adequation-expertise.b947b189.png";